import { useGenericModal } from '..';
import {
  DeleteChannelModal,
  DeleteChannelModalProps,
} from './delete-channel-modal';

export const useDeleteChannelModal = (
  props: Partial<DeleteChannelModalProps>
) => {
  const { modalRef, openModal, closeModal } = useGenericModal();

  const modalComponent = (
    <DeleteChannelModal
      {...props}
      modalRef={modalRef}
      onClose={closeModal}
      channel={props.channel || null}
    />
  );

  return {
    modalRef,
    openModal,
    closeModal,
    deleteChannelModal: modalComponent,
  };
};
